import { graphConfigGroup } from './authConfig';
export async function callMsGraphGroup(accessToken: any) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append('Authorization', bearer);

  const options = {
    method: 'GET',
    headers: headers,
  };

  try {
    const response = await fetch(graphConfigGroup.graphMeEndpoint, options);
    if (!response.ok) {
      return [];
    }
    const json = await response.json();
    const value = Array.isArray(json?.value) ? json.value : [];
    const groups = value.map((g: any) => g.id).filter(Boolean);
    return groups;
  } catch (error) {
    return [];
  }
}

/**
 * ตรวจสอบว่า user อยู่ใน group ที่กำหนดหรือไม่
 * ใช้ POST /me/checkMemberGroups — ต้องการแค่ scope "User.Read" (ไม่ต้อง admin consent)
 * คืนค่า array ของ groupId ที่ user เป็นสมาชิก (subset ของ groupIds ที่ส่งเข้ามา)
 */
export async function checkMsGraphGroupMembership(
  accessToken: string,
  groupIds: string[]
): Promise<string[]> {
  if (!groupIds || groupIds.length === 0) return [];

  const headers = new Headers();
  headers.append('Authorization', `Bearer ${accessToken}`);
  headers.append('Content-Type', 'application/json');

  try {
    const response = await fetch('https://graph.microsoft.com/v1.0/me/checkMemberGroups', {
      method: 'POST',
      headers,
      body: JSON.stringify({ groupIds }),
    });
    if (!response.ok) {
      return [];
    }
    const json = await response.json();
    return Array.isArray(json?.value) ? json.value : [];
  } catch (error) {
    return [];
  }
}
